import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  s9 as THROW_CCE,
  u7 as last,
  f as _Char___init__impl__6a9atx,
  q7 as isBlank,
  p2 as flatten,
  s2 as joinToString,
  f7 as Regex,
  a1 as Unit_getInstance,
  t2 as joinToString_0,
  e6 as isInterface,
  da as throwUninitializedPropertyAccessException,
  p5 as classMeta,
  j1 as LinkedHashMap,
  z1 as checkIndexOverflow,
  c4 as toList,
} from './kotlin-kotlin-stdlib.mjs';
import { b as update } from './net.akehurst.kotlin.html5-html-builder.mjs';
import {
  u as AglEditorJsAbstract,
  d as Companion_getInstance,
  x as AglTokenizerByWorker,
} from './net.akehurst.language.editor-agl-editor-common.mjs';
import {
  b as removeClass,
  a as addClass,
} from './kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.mjs';
import { l7 as SentenceContext } from './net.akehurst.language-agl-processor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class BuildConfig_0 {
  constructor() {
    BuildConfig_instance = this;
    this.version = '1.9.20-Beta';
    this.buildStamp = '2023-09-29T11:11:46.823002Z[UTC]';
    this.buildDate = '2023-Sept-29';
    this.buildTime = '11:11:46 UTC';
    this.versionEditorAgl = '1.9.20-Beta';
  }
  nt() {
    return this.version;
  }
  ot() {
    return this.buildStamp;
  }
  pt() {
    return this.buildDate;
  }
  qt() {
    return this.buildTime;
  }
  f52() {
    return this.versionEditorAgl;
  }
}
class AglEditorDefault extends AglEditorJsAbstract {
  constructor(containerElement, languageId, editorId, logFunction, worker) {
    super(languageId, editorId, logFunction, worker);
    this.containerElement = containerElement;
    this.o52_1 = null;
    init_(this);
  }
  p52() {
    return this.containerElement;
  }
  x4c() {
    return this;
  }
  g4d(value) {
    this.editing.value = value;
  }
  u1p() {
    return this.editing.value;
  }
  resetTokenization() {
    highlight(this, this.text);
  }
  createIssueMarkers(issues) {
  }
  k4n() {
    return 'session';
  }
  updateLanguage(oldId) {
    if (!(null == oldId)) {
      var oldAglStyleClass = Companion_getInstance().languageIdToStyleClass(this.agl.styleHandler.cssClassPrefixStart, oldId);
      removeClass(this.containerElement, [oldAglStyleClass]);
    }
    addClass(this.containerElement, [this.agl.styleHandler.aglStyleClass]);
  }
  updateStyle() {
  }
  processSentence() {
    if (this.doUpdate) {
      this.clearErrorMarkers();
      this.aglWorker.interrupt(this.languageIdentity, this.editorId, this.sessionId);
      var tmp = this.aglWorker;
      var tmp_0 = this.languageIdentity;
      var tmp_1 = this.sessionId;
      var tmp_2 = this.agl.goalRule;
      var tmp_3 = this.text;
      var tmp_4 = this.agl.context;
      tmp.processSentence(tmp_0, this.editorId, tmp_1, tmp_2, tmp_3, (tmp_4 == null ? true : isInterface(tmp_4, SentenceContext)) ? tmp_4 : THROW_CCE());
    }
  }
  configureSyntaxAnalyser(configuration) {
  }
  clearErrorMarkers() {
  }
  destroy() {
  }
  q52(_set____db54di) {
    this.m52_1 = _set____db54di;
  }
  r52() {
    var tmp = this.m52_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('editing');
    }
  }
  s52(_set____db54di) {
    this.n52_1 = _set____db54di;
  }
  t52() {
    var tmp = this.n52_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('highlightedContent');
    }
  }
  get editing() {
    return this.r52();
  }
  set editing(value) {
    this.q52(value);
  }
  get highlightedContent() {
    return this.t52();
  }
  set highlightedContent(value) {
    this.s52(value);
  }
}
class AglTokenizerByWorkerDefault {
  constructor(agl) {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.u52_1 = tmp$ret$0;
    this.v52_1 = false;
  }
  u4n() {
    return this.u52_1;
  }
  s4n(_set____db54di) {
    this.v52_1 = _set____db54di;
  }
  t4n() {
    return this.v52_1;
  }
  reset() {
    this.v52_1 = false;
    this.u52_1.n1();
  }
  receiveTokens(lineTokens) {
    if (this.v52_1) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = lineTokens.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.editor.browser.agl.AglTokenizerByWorkerDefault.receiveTokens.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var tmp0_anonymous = checkIndexOverflow(tmp1);
        var tmp$ret$0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp$ret$0 = !item.y();
        if (tmp$ret$0) {
          // Inline function 'kotlin.collections.set' call
          var tmp0_set = this.u52_1;
          var tmp1_set = toList(item);
          tmp0_set.m3(tmp0_anonymous, tmp1_set);
        } else {
        }
      }
    }
  }
  get tokensByLine() {
    return this.u4n();
  }
  get acceptingTokens() {
    return this.t4n();
  }
  set acceptingTokens(value) {
    this.s4n(value);
  }
}
//endregion
var BuildConfig_instance;
function BuildConfig_getInstance() {
  if (BuildConfig_instance === VOID)
    new BuildConfig_0();
  return BuildConfig_instance;
}
function attachToAglEditor(_this__u8e3s4, containerElement, languageId, editorId, logFunction, worker) {
  return new AglEditorDefault(containerElement, languageId, editorId, logFunction, worker);
}
function init_($this) {
  update($this.containerElement, AglEditorDefault$init_$lambda);
  var css = '\n.agl-editor {\n  display: grid;\n  grid-template-areas: "one";\n}\n.editing, .highlighted-pre {\n  display: grid;\n  grid-area: one; \n  overflow: auto;\n  text-wrap: nowrap; /* enable horizontal scroll */\n  white-space-collapse: preserve;\n  \n  margin: 0;\n  padding: 1.2em;\n  padding-bottom: 50%;\n}\n\n.editing, .highlighted-pre, .highlighted-pre * {\n  font-size: 15pt;\n  font-family: monospace;\n  line-height: 1.5;\n  tab-size: 2;\n}\n\n/* editing text area in front of result highlighting\n   and editing should be transparent\n*/\n.editing {\n  z-index: 1;\n  color: transparent;\n  background: transparent;\n  caret-color: blue;\n}\n.highlighted-pre {\n  z-index: 0;\n\n}\n.highlighted-code {\n\n}\n';
  var tmp0_safe_receiver = document.head;
  if (tmp0_safe_receiver == null)
    null;
  else {
    update(tmp0_safe_receiver, AglEditorDefault$init_$lambda_0(css));
  }
  var tmp = $this;
  var tmp_0 = $this.containerElement.querySelector('.editing');
  tmp.m52_1 = tmp_0 instanceof HTMLTextAreaElement ? tmp_0 : THROW_CCE();
  var tmp_1 = $this;
  var tmp_2 = $this.containerElement.querySelector('.highlighted-content');
  tmp_1.n52_1 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
  var tmp_3 = $this.editing;
  tmp_3.oninput = AglEditorDefault$oninput$ref($this);
  var tmp_4 = $this.editing;
  tmp_4.onscroll = AglEditorDefault$onscroll$ref($this);
  var tmp_5 = $this.editing;
  tmp_5.onkeydown = AglEditorDefault$onkeydown$ref($this);
  $this.connectWorker(new AglTokenizerByWorkerDefault($this.agl));
  $this.updateLanguage(null);
  $this.updateProcessor();
  $this.updateStyle();
}
function oninput($this, ev) {
  var newText = $this.editing.value;
  if (isBlank(newText)) {
    $this.highlightedContent.innerHTML = '';
  } else {
    if (last(newText) === _Char___init__impl__6a9atx(10)) {
      newText = newText + ' ';
    }
  }
  textUpdated($this);
}
function onscroll($this, ev) {
}
function onkeydown($this, ev) {
}
function textUpdated($this) {
  if ($this.doUpdate) {
    $this.workerTokenizer.reset();
    window.clearTimeout($this.o52_1);
    var tmp = $this;
    var tmp_0 = window;
    tmp.o52_1 = tmp_0.setTimeout(AglEditorDefault$textUpdated$lambda($this), 500);
  }
}
function highlight($this, inputText) {
  var tmp = flatten($this.workerTokenizer.tokensByLine.k3());
  var tokenised = joinToString(tmp, '', VOID, VOID, VOID, VOID, AglEditorDefault$highlight$lambda);
  // Inline function 'kotlin.text.replace' call
  // Inline function 'kotlin.text.replace' call
  var tmp1_replace = Regex.hb('&').ob(tokenised, '&amp;');
  var encoded = Regex.hb('<').ob(tmp1_replace, '&lt;');
  $this.highlightedContent.innerHTML = encoded;
}
function AglEditorDefault$init_$lambda($this$update) {
  $this$update.class_.add('agl-editor');
  $this$update.textarea(AglEditorDefault$init_$lambda$lambda);
  $this$update.htmlElement('pre', AglEditorDefault$init_$lambda$lambda_0);
  return Unit_getInstance();
}
function AglEditorDefault$init_$lambda$lambda($this$textarea) {
  $this$textarea.class_.add('editing');
  return Unit_getInstance();
}
function AglEditorDefault$init_$lambda$lambda_0($this$htmlElement) {
  $this$htmlElement.class_.add('highlighted-pre');
  $this$htmlElement.code(AglEditorDefault$init_$lambda$lambda$lambda);
  return Unit_getInstance();
}
function AglEditorDefault$init_$lambda$lambda$lambda($this$code) {
  $this$code.class_.add('highlighted-content');
  return Unit_getInstance();
}
function AglEditorDefault$init_$lambda_0($css) {
  return function ($this$update) {
    $this$update.htmlElement('style').textContent = $css;
    return Unit_getInstance();
  };
}
function AglEditorDefault$oninput$ref($boundThis) {
  var l = function (p0) {
    oninput($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'oninput';
  return l;
}
function AglEditorDefault$onscroll$ref($boundThis) {
  var l = function (p0) {
    onscroll($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'onscroll';
  return l;
}
function AglEditorDefault$onkeydown$ref($boundThis) {
  var l = function (p0) {
    onkeydown($boundThis, p0);
    return Unit_getInstance();
  };
  l.callableName = 'onkeydown';
  return l;
}
function AglEditorDefault$textUpdated$lambda(this$0) {
  return function () {
    this$0.workerTokenizer.acceptingTokens = true;
    this$0.processSentence();
    return Unit_getInstance();
  };
}
function AglEditorDefault$highlight$lambda(it) {
  var class_ = joinToString_0(it.styles, ' ');
  return "<span class='" + class_ + "'>" + it.value + '<\/span>';
}
//region block: post-declaration
setMetadataFor(BuildConfig_0, 'BuildConfig', objectMeta);
setMetadataFor(AglEditorDefault, 'AglEditorDefault', classMeta);
setMetadataFor(AglTokenizerByWorkerDefault, 'AglTokenizerByWorkerDefault', classMeta, VOID, [AglTokenizerByWorker]);
//endregion
//region block: exports
var BuildConfig = {getInstance: BuildConfig_getInstance};
export {
  BuildConfig,
  attachToAglEditor,
  AglEditorDefault,
  AglTokenizerByWorkerDefault,
};
export {
  attachToAglEditor as a,
};
//endregion

//# sourceMappingURL=net.akehurst.language.editor-agl-editor-browser-agl.mjs.map
